import { Routes } from '@angular/router';
import { AnalysisDetail } from './pages/analysis-detail/analysis-detail';

export const analysesRoutes: Routes = [
  {
    path: ':analysisId',
    component: AnalysisDetail,
    data: { title: 'Analyse' },
  },
];
